import { render, staticRenderFns } from "./BillingUpgrade.vue?vue&type=template&id=20c06e24&"
import script from "./BillingUpgrade.vue?vue&type=script&lang=js&"
export * from "./BillingUpgrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports